import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LinkService {

    toRoute(relative: string) {
        if (!relative) return relative
        if (relative.startsWith('/')) return relative
        if (relative.match('^https?://')) throw new Error(`invalid relative link ${relative}`)
        return '/' + relative
    }

}
